<template>
    <div>
        <v-dialog
            v-if="$vuetify.display.mdAndUp"
            v-bind="modal.modalAttrs.desktop"
            v-model="visibility"
            :attach="attachTo"
            :style="modal.modalAttrs.desktop.style">
            <component
                :is="modal.component"
                v-bind="modal.componentAttrs.desktop"
                @close="visibility = false" />
        </v-dialog>
        <v-bottom-sheet
            v-else
            v-bind="modal.modalAttrs.mobile"
            v-model="visibility"
            :attach="attachTo"
            :style="modal.modalAttrs.mobile.style">
            <component
                :is="modal.component"
                v-bind="modal.componentAttrs.mobile"
                @close="visibility = false" />
        </v-bottom-sheet>
    </div>
</template>

<script>
export default {
    name: 'ModalDynamicWrapper',
    emits: ['open', 'close'],
    props: {
        modal: {
            type: Object,
            default: () => {
                return {};
            },
        },
        attachTo: {
            type: String,
            default: '#app',
        },
    },
    data() {
        return {
            visibility: false,
        };
    },
    watch: {
        visibility: function (newValue) {
            if (!newValue) {
                !this.modal.events.beforeClose || this.modal.events.beforeClose();
                setTimeout(() => {
                    !this.modal.events.close || this.modal.events.close();
                    this.$emit('close');
                }, 200);
            } else {
                !this.modal.events.beforeOpen || this.modal.events.beforeOpen();
                setTimeout(() => {
                    !this.modal.events.open || this.modal.events.open();
                    this.$emit('open');
                }, 200);
            }
        },
    },
    mounted() {
        this.visibility = true;
    },
};
</script>
